import type { VisitDto } from "@repo/data-store";
import { Badge } from "@repo/ui/components/ui/badge";
import { Button } from "@repo/ui/components/ui/button";
import { Clock } from "lucide-react";
import { useMemo } from "react";
import { useSessionPanelActions } from "@/app/providers/use-session-panel";
import { useNow } from "@/shared/lib/clock-store";

interface ActiveSessionsIndicatorProps {
  visits: VisitDto[];
}

export function ActiveSessionsIndicator({ visits }: ActiveSessionsIndicatorProps) {
  const { togglePanel } = useSessionPanelActions();
  const now = useNow();

  const hasOverdue = useMemo(
    () =>
      visits.some((v) => {
        if (!v.end) return false;
        return now.getTime() > new Date(v.end).getTime();
      }),
    [visits, now],
  );

  if (visits.length === 0) return null;

  return (
    <Button variant="ghost" className="h-auto p-0 hover:bg-transparent" onClick={togglePanel}>
      <Badge variant={hasOverdue ? "destructive" : "outline"} className="cursor-pointer gap-1.5">
        <Clock className="h-3 w-3" />
        {visits.length} {visits.length === 1 ? "visit" : "visits"} in-progress
      </Badge>
    </Button>
  );
}
